import { render, staticRenderFns } from "./HorizontalTabs.vue?vue&type=template&id=09a5339e&scoped=true&"
import script from "./HorizontalTabs.vue?vue&type=script&lang=js&"
export * from "./HorizontalTabs.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTabs.vue?vue&type=style&index=0&id=09a5339e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a5339e",
  null
  
)

export default component.exports